import React from "react";

interface PropsInterface {}

const Layout500: React.FC<PropsInterface> = () => {
    return <div>Internal Server Error</div>;
};

export default Layout500;
